import WorkbenchProvider from "../../context/WorkbenchContext";
import SemanticHeader from "../SemanticModel/SemanticHeader";
import "./semanticLayout.scss";

const SemanticModelLayout = ({ children, config }: any) => {
  return (
    <div className="sidebar_container_ltr layout">
      <WorkbenchProvider>
        <div className="header_outlet_wrapper">
          <SemanticHeader config={config}/>
        </div>
        <main>{children}</main>
      </WorkbenchProvider>
    </div>
  );
};

export default SemanticModelLayout;
